"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var isUndefined = require('lodash/isUndefined');

var formatters = require('./formatters');

var conditions = require('./conditions');
/**
 * computes a property given a set of options
 * @param {Product|Component} object
 * @param {Object} setting
 *
 * @example
 * const setting = {
 *   "label": "COLORS",
 *   "value": {
 *     "key": "ink_colors",
 *     "formatter": "join",
 *     "delimiter": ", "
 *   }
 * }
 * const product = {
 *     ink_colors: ['Black', 'Lavender']
 * }
 * computeProperty(product, setting)
 * // => {
 * //   label: 'COLORS',
 * //   value: 'Black, Lavender',
 * //   delimiter: ':',
 * //   level: 0,
 * // }
 *
 * @example
 * const setting = {
 *   "label" : [
 *     {
 *       "key": "product_type",
 *       "formatter": "upperCase"
 *     },
 *     {
 *       "key": "version",
 *       "formatter": "upperCase",
 *       "condition": {
 *         "comparator": "match",
 *         "key": "version",
 *         "value": "regexp:/[A-Z]+/"
 *       }
 *     }
 *   ],
 *   "value": {
 *     "key": "quantity"
 *   }
 *   "delimiter": " -",
 *   "level": 1
 * }
 * const component = {
 *   "product_type": "invitation",
 *   "version": "A"
 *   "quantity": 55
 * }
 * computeProperty(component, setting)
 * // => {
 * //   label: 'INVITATION A',
 * //   value: 55,
 * //   delimiter: ' -',
 * //   level: 1
 * // }
 */


function unconditional() {
  return true;
}

function noChange(a) {
  return a;
}

function computePropertyFromSetting(object, setting) {
  var condition = setting.condition ? conditions[setting.condition.comparator] : unconditional;
  var key = setting.key;
  var value = setting.value || object[key];
  var formattedValue; // allows multiple formatters to be chained, e.g. join => upperCase => val

  if (setting.formatters && Array.isArray(setting.formatters)) {
    formattedValue = setting.formatters.reduce(function (accumulator, _ref) {
      var formatter = _ref.formatter,
          settings = _objectWithoutProperties(_ref, ["formatter"]);

      var fn = formatters[formatter];

      if (typeof fn !== 'function') {
        throw new Error("".concat(formatter, " was not found in formatters"));
      }

      return fn(accumulator, settings);
    }, value);
  } else {
    // one formatter (or none)
    var formatter = formatters[setting.formatter] || noChange;
    formattedValue = formatter(value, setting);
  }

  if (condition(object, setting.condition)) {
    return String(formattedValue);
  } // must return a string if we mean to return an otherwise falsy value (e.g. '0' and not 0)


  return null;
}

function computeNestedProperty(object, settings) {
  if (Object.prototype.toString.call(settings) === '[object Object]') {
    return computePropertyFromSetting(object, settings);
  }

  if (Object.prototype.toString.call(settings) === '[object Array]') {
    return settings.map(function (setting) {
      return computePropertyFromSetting(object, setting);
    }).filter(function (setting) {
      return setting;
    }).join(' ');
  }

  return settings;
}
/**
 * @class
 * @param {Object} params
 * @param {String} params.label e.g. "INVITATIONS"
 * @param {String} params.value e.g. "25"
 * @param {String} params.delimiter e.g. ":"
 * @param {Number} params.level e.g. 0
 */


var ComputedProperty = function ComputedProperty() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  _classCallCheck(this, ComputedProperty);

  this.component = params.component || '';
  this.label = params.label || '';
  this.value = params.value || '';
  this.delimiter = params.delimiter || '';
  this.level = params.level || 0;
};

function computeProperty(object, setting) {
  var label = computeNestedProperty(object, setting.label);
  var value = computeNestedProperty(object, setting.value);
  var delimiter = isUndefined(setting.delimiter) ? ': ' : setting.delimiter;
  var level = setting.level || 0;

  if (value === '') {
    return null;
  }

  return new ComputedProperty({
    component: object.type,
    label: label,
    value: value,
    delimiter: delimiter,
    level: level
  });
}

module.exports = computeProperty;